/**
 * @file memberUtils.js
 * @location src/utils/memberUtils.js
 * @role 멤버 ID → 표시값 변환 헬퍼 (members 배열을 인자로 받는 순수 함수)
 *
 * 호출 컨벤션:
 *   const { S } = useApp();
 *   mname(id, S.members)  // 'm1' → '표한결'
 *
 * mname(id, members)              멤버 이름
 * kubunLabel(isManager)           구분 라벨 (boolean 직접) — UI 인라인 삼항 단일화
 * mrole(id, members)              구분 라벨 (매니저/멤버) — razor ⑳ 직급 폐기
 * isManagerById(id, members)      id 로 매니저(★) 여부 (관리 게이트 — 업무 송신은 razor 로 전원 개방)
 * getInitials(name)               아바타 이니셜 2자
 */

// razor: 삭제된·존재 안 하는 멤버 fallback 「알 수 없음」 — 라벨·aria 일관 razor.
// pending 멤버는 m.name 이 빈 문자열 → 「초대 중인 자리」 표시는 호출 측에서 별도 (MemberRow).
export const mname     = (id, members = []) => members.find(m => m.id === id)?.name || '알 수 없음';

/** 구분 라벨 (isManager boolean 직접) — 매니저/멤버. UI 인라인 삼항 단일 소스. */
export const kubunLabel = (isManager) => (isManager ? '매니저' : '멤버');

/** 구분 라벨 — razor ⑳: 직급 폐기, 매니저/멤버 (isManager) */
export const mrole     = (id, members = []) =>
  kubunLabel(!!members.find(m => m.id === id)?.isManager);

export const isManagerById = (id, members = []) =>
  !!members.find(m => m.id === id)?.isManager;

/** 이름에서 아바타 이니셜 2자 추출  예) '표한결' → '표한' */
export const getInitials = (name) => (name ?? '').replace(' ', '').slice(0, 2);
